import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';
import Image from '../../components/Image';
import useLocales from '../../hooks/useLocales';
import { useDispatch } from '../../redux/store';
import conObj from '../../utils/connection-assistant';
import { getOperatingSystem } from '../../utils/formatObject';
import { openLoginSignup } from '../../redux/slices/authPages';
import palette from '../../theme/palette';

const GameContainer = ({
  item,
  companySlug = null,
  containerSx = {},
  imgWrapperSx = {},
  titleSx = {},
  lastSlotRef = null,
  isProvider = false,
}) => {
  const isAuthenticated = localStorage.getItem('accessToken');

  const dispatch = useDispatch();

  const { translate } = useLocales();

  const [isShowOverlay, setIsShowOverlay] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const handleLaunchGame = (code) => {
    setIsLoading(true);

    const newTab = window.open();

    newTab.document.write(
      '<div style="text-align: center; width: 100%; height: 100%;font-family: monospace, sans-serif; font-size: 2rem; color: black; font-weight: 900; margin-top: 5rem;">Loading game site...</div>'
    );

    conObj
      .post(`games/launch/${code}.json`, {
        system_os: getOperatingSystem(),
        is_mobile: isMobile ? 1 : 0,
        return_url: window.location.href,
      })
      .then((res) => {
        if (res.status === 200) {
          const { status } = res.data.data;
          if (status === 1) {
            newTab.location.href = res.data?.data?.data?.url;
            setIsLoading(false);
          }
        }
      })
      .catch((err) => {
        const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
        enqueueSnackbar(err.message, snackbarOptions);
        console.log(`Server Error: ${err.message}`);
        setIsLoading(false);
        newTab.close();
      });
  };

  const handleGameClick = () => {
    if (item?.is_maintenance_mode) return;

    setIsShowOverlay(false);

    if (item?.is_parent) {
      navigate(`/games/${companySlug}/${item.id}`, {
        state: {
          parentKey: item?.filter_parent_key,
          gameName: item?.name,
        },
      });

      return;
    }

    if (companySlug && !item?.is_single_game) {
      navigate(`/games/${companySlug}/${item.id}`);
      return;
    }

    if (isAuthenticated) {
      if (item?.is_single_game && item?.single_game_game_code) handleLaunchGame(item?.single_game_game_code);
      else handleLaunchGame(item.code);
    } else dispatch(openLoginSignup({ open: true, isLogin: true }));
  };

  return (
    // Container
    <Box
      onMouseEnter={() => setIsShowOverlay(true)}
      onMouseLeave={() => setIsShowOverlay(false)}
      onClick={handleGameClick}
      sx={{
        position: 'relative',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 1,
        height: '100%',
        overflow: 'hidden',
        aspectRatio: isProvider ? '4 / 3' : '1 / 1',
        ...containerSx,
      }}
      data-company={companySlug}
      ref={lastSlotRef}
    >
      {/* Image Wrapper */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          ...imgWrapperSx,
        }}
      >
        <Image
          src={item?.photo_url || item?.icon_url || ''}
          alt={item.name}
          sx={{
            aspectRatio: isProvider ? '4 / 3' : '1 / 1',
            // width: '100%',
            // height: '100%',
            // width: { md: '162px', sm: '28vw', xs: '28vw' },
            // height: { md: '162px', sm: '28vw', xs: '28vw' },
            maxWidth: '100%',
            maxHeight: '100%',
            cursor: 'pointer',
            filter: `brightness(${item.is_maintenance_mode ? '0.2' : '1'})`,
            // filter: `brightness(${item.is_maintenance_mode ? '0.2' : '1'}) blur(${
            //   isShowOverlay && !item.is_maintenance_mode ? 3 : 0
            // }px)`,
            img: {
              objectFit: isProvider ? 'contain' : 'cover',
            },
          }}
        />
      </Box>
      {item.is_maintenance_mode && (
        <Typography
          sx={{
            position: 'absolute',
            color: '#ac0707',
            fontWeight: 600,
            textShadow: '0px 0px 1px #7f7f7f',
            textAlign: 'center',
          }}
        >
          {translate('in_maintenance')}
        </Typography>
      )}
      {/* isShowOverlay && !item.is_maintenance_mode ? ( */}
      {/* <AnimatePresence>
          <Box
            component={m.div}
            {...varFade({
              distance: 120,
              durationIn: 0.32,
              durationOut: 0.24,
              easeIn: 'easeInOut',
            }).in}
            sx={{
              display: 'flex',
              position: 'absolute',
              // top: '16px',
              // left: '16px',
              height: '100%',
              width: '100%',
              // backdropFilter: 'blur(3px)',
              backgroundColor: 'rgba(27,34,51,.8)',
              cursor: 'pointer',
              py: 0.5,
              px: 1,
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'end',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {companySlug && !item?.is_single_game && companySlug ? (
                  <Box
                    sx={{
                      borderRadius: '100%',
                      width: '40px',
                      height: '40px',
                      backgroundColor: '#159e1a',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Iconify icon={'ion:open'} sx={{ width: '50%' }} />
                  </Box>
                ) : (
                  <Box sx={{ width: '40%', maxHeight: '50px' }}>
                    <Image
                      src={require('../../assets/play.png')}
                      sx={{ width: '100%', height: '100%', cursor: 'pointer' }}
                    />
                  </Box>
                )}
              </Box>

              <Typography
                sx={{
                  color: '#fff',
                  textAlign: 'center',
                  fontWeight: 600,
                  letterSpacing: '-.02em',
                  fontSize: calculateFontSize(item?.name, 13, 17),
                  ...titleSx,
                }}
              >
                {item?.name}
              </Typography>
            </Box>
          </Box>
        </AnimatePresence> */}
    </Box>
  );
};

GameContainer.propTypes = {
  item: PropTypes.object,
  onClick: PropTypes.func,
  containerSx: PropTypes.object,
  imgWrapperSx: PropTypes.object,
  titleSx: PropTypes.object,
};

export default GameContainer;
